import collectionApiClient, {
  CollectionAnalyticsQueryParams,
  CountryPerformance,
  OrderGraphPeriod,
} from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useCollectionCountryPerformanceQuery = ({
  collectionId,
  period = OrderGraphPeriod.WEEK,
  enabled = true,
}: CollectionAnalyticsQueryParams) => {
  return useKlydoQuery<CountryPerformance[]>({
    queryKey: ['collectionCountryPerformance', collectionId, period],
    queryFn: () =>
      collectionApiClient.getCollectionCountryPerformance(collectionId, period),
    enabled: !!collectionId && enabled,
  });
};

export default useCollectionCountryPerformanceQuery;
